import React, { useState } from 'react';
import { Logo } from '../ui';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboardIcon, CalendarDaysIcon, SparklesIcon, UsersIcon, ClockIcon, GraduationCapIcon, UsersRoundIcon, ClipboardListIcon, BarChart3Icon, SettingsIcon, MenuIcon, XIcon, SearchIcon, BellIcon, BriefcaseIcon } from 'lucide-react';
import { Button } from '../ui';
interface DashboardLayoutProps {
  children: React.ReactNode;
  pageTitle?: string;
  breadcrumb?: string;
}
export function DashboardLayout({
  children,
  pageTitle = 'Dashboard',
  breadcrumb
}: DashboardLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const navItems = [{
    icon: <LayoutDashboardIcon className="w-5 h-5" data-id="element-1351" />,
    label: 'Dashboard',
    path: '/dashboard'
  }, {
    icon: <CalendarDaysIcon className="w-5 h-5" data-id="element-1352" />,
    label: 'Events',
    path: '/dashboard/events'
  }, {
    icon: <SparklesIcon className="w-5 h-5" data-id="element-1353" />,
    label: 'AI Designer',
    path: '/dashboard/designer'
  }, {
    icon: <UsersIcon className="w-5 h-5" data-id="element-1354" />,
    label: 'Attendees',
    path: '/dashboard/attendees'
  }, {
    icon: <ClockIcon className="w-5 h-5" data-id="element-1355" />,
    label: 'Agenda',
    path: '/dashboard/agenda'
  }, {
    icon: <GraduationCapIcon className="w-5 h-5" data-id="element-1356" />,
    label: 'Learning',
    path: '/dashboard/learning'
  }, {
    icon: <UsersRoundIcon className="w-5 h-5" data-id="element-1357" />,
    label: 'Groups',
    path: '/dashboard/groups'
  }, {
    icon: <ClipboardListIcon className="w-5 h-5" data-id="element-1358" />,
    label: 'Surveys',
    path: '/dashboard/surveys'
  }, {
    icon: <BarChart3Icon className="w-5 h-5" data-id="element-1359" />,
    label: 'Reports',
    path: '/dashboard/reports'
  }, {
    icon: <BriefcaseIcon className="w-5 h-5" data-id="element-1360" />,
    label: 'Client Book',
    path: '/dashboard/clients'
  }, {
    icon: <SettingsIcon className="w-5 h-5" data-id="element-1361" />,
    label: 'Settings',
    path: '/dashboard/settings'
  }];
  return <div className="min-h-screen bg-slate-50 flex" data-id="element-1362">
      {/* Sidebar - Desktop */}
      <aside className="hidden lg:flex lg:flex-col lg:w-64 bg-white border-r border-slate-200 fixed h-full z-30" data-id="element-1363">
        <div className="p-6 border-b border-slate-100" data-id="element-1364">
          <Logo data-id="element-1365" />
        </div>

        <nav className="flex-1 p-4 space-y-1 overflow-y-auto" data-id="element-1366">
          {navItems.map(item => {
          const isActive = location.pathname === item.path;
          return <Link key={item.path} to={item.path} className={`flex items-center gap-3 px-4 py-2.5 rounded-lg transition-colors relative ${isActive ? 'bg-brand-navy/5 text-brand-navy font-medium' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-1367">
                {isActive && <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-brand-coral rounded-r" data-id="element-1368" />}
                {item.icon}
                <span className="text-sm" data-id="element-1369">{item.label}</span>
              </Link>;
        })}
        </nav>

        <div className="p-4 border-t border-slate-100" data-id="element-1370">
          <div className="flex items-center gap-3 px-4 py-3 rounded-lg bg-slate-50" data-id="element-1371">
            <div className="w-10 h-10 rounded-full bg-brand-navy text-white flex items-center justify-center font-bold text-sm" data-id="element-1372">
              SM
            </div>
            <div className="flex-1 min-w-0" data-id="element-1373">
              <div className="text-sm font-medium text-slate-900 truncate" data-id="element-1374">
                Sarah Mitchell
              </div>
              <div className="text-xs text-slate-500 truncate" data-id="element-1375">
                MICE Planner
              </div>
            </div>
          </div>
        </div>
      </aside>

      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && <div className="lg:hidden fixed inset-0 bg-black/50 z-40" onClick={() => setSidebarOpen(false)} data-id="element-1376">
          <aside className="w-64 bg-white h-full" onClick={e => e.stopPropagation()} data-id="element-1377">
            <div className="p-6 border-b border-slate-100 flex items-center justify-between" data-id="element-1378">
              <Logo data-id="element-1379" />
              <button onClick={() => setSidebarOpen(false)} className="p-2 text-slate-600" data-id="element-1380">
                <XIcon className="w-5 h-5" data-id="element-1381" />
              </button>
            </div>

            <nav className="p-4 space-y-1" data-id="element-1382">
              {navItems.map(item => {
            const isActive = location.pathname === item.path;
            return <Link key={item.path} to={item.path} onClick={() => setSidebarOpen(false)} className={`flex items-center gap-3 px-4 py-2.5 rounded-lg transition-colors relative ${isActive ? 'bg-brand-navy/5 text-brand-navy font-medium' : 'text-slate-600 hover:bg-slate-50'}`} data-id="element-1383">
                    {isActive && <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-brand-coral rounded-r" data-id="element-1384" />}
                    {item.icon}
                    <span className="text-sm" data-id="element-1385">{item.label}</span>
                  </Link>;
          })}
            </nav>
          </aside>
        </div>}

      {/* Main Content */}
      <div className="flex-1 lg:ml-64" data-id="element-1386">
        {/* Top Bar */}
        <header className="bg-white border-b border-slate-200 sticky top-0 z-20" data-id="element-1387">
          <div className="px-6 py-4 flex items-center justify-between gap-4" data-id="element-1388">
            <div className="flex items-center gap-4" data-id="element-1389">
              <button onClick={() => setSidebarOpen(true)} className="lg:hidden p-2 text-slate-600 hover:bg-slate-100 rounded-lg" data-id="element-1390">
                <MenuIcon className="w-5 h-5" data-id="element-1391" />
              </button>
              <div data-id="element-1392">
                <h1 className="text-xl font-bold text-brand-navy" data-id="element-1393">
                  {pageTitle}
                </h1>
                {breadcrumb && <p className="text-sm text-slate-500" data-id="element-1394">{breadcrumb}</p>}
              </div>
            </div>

            <div className="flex items-center gap-3" data-id="element-1395">
              <div className="hidden md:flex items-center gap-2 bg-slate-50 px-4 py-2 rounded-lg border border-slate-200 w-64" data-id="element-1396">
                <SearchIcon className="w-4 h-4 text-slate-400" data-id="element-1397" />
                <input type="text" placeholder="Search..." className="bg-transparent border-none outline-none text-sm w-full text-slate-700 placeholder:text-slate-400" data-id="element-1398" />
              </div>
              <button className="relative p-2 text-slate-600 hover:bg-slate-100 rounded-lg" data-id="element-1399">
                <BellIcon className="w-5 h-5" data-id="element-1400" />
                <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-brand-coral rounded-full" data-id="element-1401"></span>
              </button>
              <Button variant="accent" size="sm" href="/event-hub" data-id="element-1402">
                Launch Event Hub
              </Button>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="p-6 md:p-8 max-w-[1600px]" data-id="element-1403">{children}</main>
      </div>
    </div>;
}